import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'datetimeFormat',
})
export class DatetimeFormatPipe implements PipeTransform {
  transform(value: string): string | null {
    if (!value) return '-';

    const date = new Date(value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
}
